import React from "react";

const Modal = ({ isOpen, onClose, children, width='max-w-[750px]' }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50"
        onClick={onClose}
      />

      {/* Sidebar */}
     <div className={`relative w-full ${width} h-full bg-card border-l border-border shadow-xl animate-slide-in-from-right `}>
        {children}
      </div>
    </div>
  );
};

export default Modal;
